import React from "react";
import {
  Paper, List, ListItem, ListItemAvatar, Avatar,
  ListItemText, ListItemSecondaryAction, Box, Typography, Button
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function UsersListSimple({ users, onEdit, disabled }) {
  const { t } = useTranslation();

  return (
    <Paper variant="outlined">
      <List dense>
        {users.length ? (
          users.map((up) => {
            const u = up.user || {};
            return (
              <ListItem key={up.id} divider>
                <ListItemAvatar>
                  <Avatar>{(u.username || "?")[0]?.toUpperCase()}</Avatar>
                </ListItemAvatar>

                <ListItemText
                  primary={<Typography sx={{ fontWeight: 600 }}>{u.username || "—"}</Typography>}
                  secondary={
                    <Typography variant="body2" color="text.secondary">
                      {`${u.first_name || ""} ${u.last_name || ""}`.trim() || "—"}
                      {u.email ? ` • ${u.email}` : ""}
                      {up.dataview_pin ? ` • PIN: ${up.dataview_pin}` : ""}
                    </Typography>
                  }
                />

                <ListItemSecondaryAction>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<Edit />}
                    onClick={() => onEdit(up)}
                    disabled={disabled}
                  >
                    {t("usersList.actions.edit", "Edit")}
                  </Button>
                </ListItemSecondaryAction>
              </ListItem>
            );
          })
        ) : (
          <Box p={2}>
            <Typography variant="body2" color="text.secondary">
              {t("usersList.empty", "No users.")}
            </Typography>
          </Box>
        )}
      </List>
    </Paper>
  );
}